/**
 * Implements text search with fuzzy matching & case-insensitivity.
 *
 * I.e. "ANN" matches "banana".
 *                      ^^ ^
 **/
export function fuzzyTextSearch<T>(
  items: Iterable<T>,
  search: string,
  getItemText: (item: T) => string,
): T[] {
  search = search.toLowerCase().trim().normalize('NFC');
  if (search.length === 0) return [...items];

  const out = [];
  for (const item of items) {
    const nameNorm = getItemText(item).toLowerCase().normalize('NFC');
    if (nameNorm.length < search.length) continue;
    for (let i = 0, j = 0; i < nameNorm.length; i++) {
      if (nameNorm[i] === search[j]) {
        j++;
        if (j === search.length) {
          out.push(item);
          break;
        }
      }
    }
  }
  return out;
}
